import { AttributionCountry } from '@products/models/attribution';
import { AttributionCountryDTO, CurrencyCode, FundId } from '@types';
import { MapperFactory } from './mapper-factory';
import { Mapper, MapperParams } from './type.mapper';

export class AttributionCountriesMapper extends Mapper<AttributionCountry[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    attributionCountriesDTO: AttributionCountryDTO[]
  ): AttributionCountry[] {
    const attributionCountries: AttributionCountry[] = [];

    attributionCountriesDTO.forEach(
      (attributionCountryDTO: AttributionCountryDTO) => {
        const attributionCountry: AttributionCountry = this.createMapper(
          AttributionCountryMapper
        ).toDomain(attributionCountryDTO);

        if (attributionCountry) {
          attributionCountries.push(attributionCountry);
        }
      }
    );

    return attributionCountries;
  }
}

export class AttributionCountryMapper extends Mapper<AttributionCountry> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(attributionCountryDTO: AttributionCountryDTO): AttributionCountry {
    return {
      fundId: attributionCountryDTO.fundid as FundId,
      fundName: attributionCountryDTO.fundname,
      currency: attributionCountryDTO.currency as CurrencyCode,
      startDate: attributionCountryDTO.startdate,
      endDate: attributionCountryDTO.enddate,
      startDateStd: attributionCountryDTO.startdatestd,
      endDateStd: attributionCountryDTO.enddatestd,
      benchmark: attributionCountryDTO.benchmark,
      portfolioAverageWeight: attributionCountryDTO.portavgweight,
      portfolioTotalReturn: attributionCountryDTO.portreturn,
      portfolioContributionToReturn: attributionCountryDTO.portcontrib,
      bmAverageWeight: attributionCountryDTO.bmavgweight,
      bmTotalReturn: attributionCountryDTO.bmreturn,
      bmContributionToReturn: attributionCountryDTO.bmcontrib,
      variationAverageWeight: attributionCountryDTO.variationavgweight,
      variationTotalReturn: attributionCountryDTO.variationreturn,
      variationContributionToReturn: attributionCountryDTO.variationcontrib,
      allocationEffectLocal: attributionCountryDTO.alloceffectlocal,
      selectionEffectLocal: attributionCountryDTO.selecteffectlocal,
      interactionEffectLocal: attributionCountryDTO.interacteffectlocal,
      totalEffectLocal: attributionCountryDTO.totaleffectlocal,
      totalCurrencyEffect: attributionCountryDTO.currencyeffect,
      allocationEffect: attributionCountryDTO.alloceffect,
      selectionEffect: attributionCountryDTO.selecteffect,
      interactionEffect: attributionCountryDTO.interacteffect,
      totalEffect: attributionCountryDTO.totaleffect,
      portfolioCurReturn: attributionCountryDTO.portcurreturn,
      portfolioContributionLocal: attributionCountryDTO.portcontriblocal,
      portfolioReturnLocal: attributionCountryDTO.portreturnlocal,
      toDateStd: attributionCountryDTO.todatestd,
      fromDateStd: attributionCountryDTO.fromdatestd,
      toDate: attributionCountryDTO.todate,
      fromDate: attributionCountryDTO.fromdate,
      levelNumber: attributionCountryDTO.levelno,
      numberOfMonths: attributionCountryDTO.noofmonths,
      calcType: attributionCountryDTO.calctype,
      bmReturnLocal: attributionCountryDTO.bmreturnlocal,
      region: attributionCountryDTO.region,
      country: attributionCountryDTO.country,
      fPeriod: attributionCountryDTO.fperiod,
    };
  }
}
